import { useContext } from "react"
import { useMutation, useQuery } from "@tanstack/react-query"
import { AuthContext } from "components/providers/Auth.provider"
import authService from "services/auth.service"
import type { TLogin, TRegistrationData, TActivateUser } from "types/auth.type"

export const useAuth = () => {
	const context = useContext(AuthContext)
	if (!context) {
		throw new Error("useAuth must be used within an AuthProvider")
	}
	return context
}

export const useLogin = () => {
	return useMutation({
		mutationKey: ["login"],
		mutationFn: (data: TLogin) => authService.login(data.email, data.password),
	})
}

export const useDestroyToken = () => {
	return useMutation({
		mutationKey: ["destroyToken"],
		mutationFn: () => authService.destroyToken(),
	})
}

export const useRegistration = () => {
	return useMutation({
		mutationKey: ["registration"],
		mutationFn: (data: TRegistrationData) =>
			authService.register(data.email, data.firstName, data.lastName, data.password, data.confirmPassword, data.token),
	})
}

export const useResendInvintation = () => {
	return useMutation({
		mutationKey: ["resendInvintation"],
		mutationFn: (email: string) => authService.resendInvintation(email),
	})
}

export const useActivateUser = () => {
	return useMutation({
		mutationKey: ["activateUser"],
		mutationFn: (data: TActivateUser) => authService.activateUser(data.id, data.token),
	})
}

export const useCheckRegisterToken = (token: string | null) => {
	return useQuery({
		queryKey: ["checkRegisterToken"],
		queryFn: () => authService.checkRegisterToken(token),
		enabled: !!token,
	})
}
